import { createReducer } from '@reduxjs/toolkit';
import { IModalState } from '../types';
import * as actions from '../actions';

const { openModal, closeModal, clearAllModals } = actions;

const initialState: IModalState = {
  currentModals: []
};

const modalsReducer = createReducer(initialState, {
  [openModal.type]: (state, { payload: { modalType, modalProps = {} } }) => {
    // 1. Check if modal type is valid
    if (false) {
      return;
    }
    // 2. if no, do nothing. if yes, append to beginning of
    state.currentModals = [...state.currentModals, { modalType, modalProps }];
  },
  [closeModal.type]: state => {
    const modalsCount = state.currentModals.length;
    // We are always closing the most stacked modal (which is the last element in the modals array).
    if (modalsCount > 0) {
      state.currentModals = state.currentModals.slice(0, modalsCount - 1);
    }
  },
  [clearAllModals.type]: state => {
    state.currentModals = [];
  }
});

export { modalsReducer };
